import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

import strings from 'rise-ui/config/strings.js';
import { timeSeriesRouteQueryParams } from 'rise-ui/services/time-series/params.js';
import { complexQueryParams } from 'rise-ui/decorators/complex-query-params.js';

@complexQueryParams
@scrollRoot
export default class TimeSeriesRoute extends Route {
  @service keywords;
  @service router;
  @service routing;
  @service('time-series/params') timeSeriesParams;

  queryParams = timeSeriesRouteQueryParams;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            this.keywords.strings['time-series-keywords'],
          ),
        },
      },
    ];
  }

  @breadcrumb crumb = strings['time-series-route'];

  setupController(controller) {
    if (!controller.v) {
      // Set current query param format version
      controller.set('v', '1');
    }
    return super.setupController(...arguments);
  }
}
